import { TimelineShift } from 'api/shift'
import { useMemo } from 'react'
import { shouldShowApproveButton } from 'lib/work'

export function useNeedsApproval(data: TimelineShift) {
  return useMemo(() => {
    return (data.work ?? []).some((work) => shouldShowApproveButton(work))
  }, [data])
}
